import { FormsModule } from '@angular/forms';
//import { MbscModule } from '@mobiscroll/angular';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CacheModule } from 'ionic-cache';
//import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ComponentsModule } from './components/components.module';

import {
  HTTP_INTERCEPTORS,
  HttpClientModule
} from '@angular/common/http';
import { HttpConfigInterceptor } from './httpConfig.interceptor';
import { Globals } from './globals';
import { DatePipe } from '@angular/common';


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
    FormsModule,
//    MbscModule,
        BrowserModule,
        IonicModule.forRoot({ mode: 'ios' }),
        AppRoutingModule,
        CacheModule.forRoot({ keyPrefix: '42-' }),
        HttpClientModule,
        IonicStorageModule.forRoot(),
        ComponentsModule,
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        Globals,
        DatePipe
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule {}
